


export default function Footer(props) {
	return (
		<section className="row">       
			<div className="explore">
				<div className="container">
					<div className="row">
						<div className="col-12">
							<h3>Explore more from BlackRock</h3>
							<div className="links-container">
								<div className="links">
									<span className="cta-box">
										<div className="cta-container-box">
											<a href="https://www.blackrock.com/us/financial-professionals/investments/products/active-fixed-income" target="_blank"  className="cta link"> 
												<span className="label">
													<span className="icon fa fa-angle-right" aria-hidden="true"></span>
													<span>Active fixed income products</span>
												</span>
											</a> 
										</div>
									</span>
									<span className="cta-box">
										<div className="cta-container-box">
											<a href="https://www.blackrock.com/us/financial-professionals/investments/products/municipal-bonds" target="_blank"  className="cta link"> 
												<span className="label">
													<span className="icon fa fa-angle-right" aria-hidden="true"></span>
													<span>Municipal bonds</span>
												</span>
											</a> 
										</div>
									</span>
									<span className="cta-box">
										<div className="cta-container-box">
											<a href="https://www.blackrock.com/us/financial-professionals/products/bond-etfs " target="_blank" className="cta link"> 
												<span className="label">
													<span className="icon fa fa-angle-right" aria-hidden="true"></span>
													<span>Bond ETFs</span>
												</span>
											</a> 
										</div>
									</span>
								</div>
							</div>
                    	</div>
               		</div>
            	</div>
        	</div>
        </section>
	)
}